import { render, staticRenderFns } from "./TheCoinbaseStakingLayout.vue?vue&type=template&id=5f011abf"
import script from "./TheCoinbaseStakingLayout.vue?vue&type=script&lang=js"
export * from "./TheCoinbaseStakingLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports